import { FC } from 'react'

import { DatabaseLineIcon, DocumentLineIcon, IconSizes } from '@inno-ui/icons'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'

import type { Mode } from '../logViewer.types'
import styles from './LogModeTabs.module.scss'

interface LogModeTabsProps {
  mode: Mode
  onSwitch: (mode: Mode) => void
}

export const LogModeTabs: FC<LogModeTabsProps> = ({ mode, onSwitch }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'desktop.log_viewer'
  })

  return (
    <div className={styles.modeTabs}>
      <button
        className={cn(styles.modeTab, {
          [styles.modeTabActive]: mode === 'live'
        })}
        onClick={() => onSwitch('live')}
      >
        <DatabaseLineIcon size={IconSizes.Size14} />
        {t('mode_live')}
      </button>
      <button
        className={cn(styles.modeTab, {
          [styles.modeTabActive]: mode === 'file'
        })}
        onClick={() => onSwitch('file')}
      >
        <DocumentLineIcon size={IconSizes.Size14} />
        {t('mode_file')}
      </button>
    </div>
  )
}
